import React,{useState,useEffect} from 'react'
import { Chip, Switch } from '@mui/material';

import AppLayout from '../../../../layout/components/AppLayout';
import suggestionServices from '../suggestionServices';
import SuggesionForm from '../components/SuggesionForm';




function ManageSuggestionPage() {
  const [suggestionList,setSuggestionList] = useState(null);
  const getSuggestionList = () =>{
    suggestionServices.getList().then(res=>{
      setSuggestionList(res.data)
    }).catch(error=>{
      console.log(error);
    })
  }
  useEffect(()=>{
    getSuggestionList()
  },[])

  const handleStatusChange = (e,id) =>{
    let payload = {
      id:id,
      status:e.target.checked ? 1 : 0,
    }
    console.log(payload);
    suggestionServices.save(payload).then(res=>{
      getSuggestionList();
    })
  }

  return (
    <AppLayout>
      <div className="container">
      <div className='row'>
        <div className='col-md-9'>
          <h3>Suggestion List</h3>
        </div>
        <div className='col-md-3'>
        <span className='float-end'><SuggesionForm refreshList={getSuggestionList} /></span>
        </div>
      </div>
      <div className='row'>
        <div className='col-md-12'>
          <table className='table'>
            <thead>
              <tr>
                <td>Suggestion</td>
                <td>Response Id</td>
              </tr>
            </thead>
            <tbody>
              {suggestionList && suggestionList.map(suggestion=>
                <tr key={suggestion.id}>
                  <td><Chip variant={suggestion.variant} color={suggestion.color} className='mt-1' label={suggestion.optionTitle} /></td>
				          <td>{suggestion.optionId}</td>
                  <td>
                    <div>
                      <SuggesionForm refreshList={getSuggestionList} data={suggestion} />
                      <Switch 
                        color="success"
                        checked={suggestion.status === 1}
                        onChange={(e)=>handleStatusChange(e,suggestion.id)}
                      />
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      </div>
    </AppLayout>
  )
}

export default ManageSuggestionPage